import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SubCategoriesState = {
    subCategories?: any[],
};

const initialState: SubCategoriesState = {
    subCategories: []
};

export const subCategoriesSlice = createSlice({
    name: 'subCategories',
    initialState,
    reducers: {
        setSubCategories: (state, action: PayloadAction<SubCategoriesState>) => {
            state.subCategories = action.payload.subCategories;
        }
    }
});

export const { setSubCategories } = subCategoriesSlice.actions;

export default subCategoriesSlice.reducer;
